/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amarantos API
 * REST API for the Amarantos construction and infrastructure management platform. Supports both the Panel (web) and App (mobile) clients.
 *
 * OpenAPI spec version: 1.0.0
 */

export type ProductCategory = typeof ProductCategory[keyof typeof ProductCategory];


export const ProductCategory = {
  manhole: 'manhole',
  tank: 'tank',
  pipe: 'pipe',
  pump_station: 'pump_station',
  soakaway: 'soakaway',
  separator: 'separator',
} as const;
